var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};

OCS.Viewer.Functions.define_layer_group_background_interface = function () {
    OCS.Viewer.Interfaces.LayerGroupBackground = {
        backgroundList: [],
        backgroundTimer: null,

        init_background_events: function () {
            this.addEvent('add_layer', this.on_add_layer_background.bind(this));
            this.addEvent('destroy_layer_group', this.stopBackgroundDraw.bind(this));
            this.addEvent('layer_active', this.on_layer_active.bind(this));
        },
        can_draw_background: function () {
            var dateObj = this.get_map_datetime_obj();
            if (!dateObj.is_animating() && !OCS.Viewer.Live.ControllerManager.map_move) {
                return true;
            }
            return false;
        },
        startBackgroundTimer: function () {
            if (this.backgroundTimer)
                this.stopBackgroundTimer();

            this.backgroundTimer = setTimeout(function () {
                this.backgroundTimer = null;
                this.drawBackgroundLayer();
            }.bind(this), 5000);
        },
        stopBackgroundTimer: function () {
            if (this.backgroundTimer) {
                clearTimeout(this.backgroundTimer);
                this.backgroundTimer = null;
            }
        },
        // Determine background drawing progress
        add_layer_to_background_list: function (layer_id) {
            this.backgroundList.push(layer_id);
        },
        stopBackgroundDraw: function () {
            this.backgroundList = [];
            this.stopBackgroundTimer();
        },
        setupBackgroundList: function () {
            this.backgroundList = [];
            if (this.is_static())
                return;

            var active_layer = this.get_active_layer();
            var activeLayerId = null;
            var active_source;
            if (active_layer) {
                activeLayerId = active_layer.get_id();
                active_source = active_layer.get_source_obj();
            }
            var layer_source;
            Object.each(this.layers, function (layer) {
                if (layer.get_id() !== activeLayerId) {
                    layer_source = layer.get_source_obj();
                    if(layer_source && layer_source.checkForRender(active_source.getRenderedResolution(), active_source.getRenderedExtent())) {
                        layer_source.drawn = false;
                        this.add_layer_to_background_list(layer.get_id());
                    }
                }
            }.bind(this));
        },
        onBackgroundDrawStart: function (inSrc, inLayer) {
            if (!this.can_draw_background()) {
                this.backgroundList = [];
                this.stopBackgroundTimer();
                return;
            }
            var active_layer = this.get_active_layer();
            var activeLayerId = null;
            if (active_layer)
                activeLayerId = active_layer.get_id();

            if (inLayer.get_id() === activeLayerId) {
                this.stopBackgroundTimer();
                this.backgroundList = [];
            }
        },
        onBackgroundDrawFinish: function (inSrc, inLayer) {
            if (!this.can_draw_background())
                return;

            var active_layer = this.get_active_layer();
            var activeLayerId = null;
            if (active_layer)
                activeLayerId = active_layer.get_id();
            

            this.startBackgroundTimer();
            if (inLayer.get_id() !== activeLayerId) {
                inLayer.background_draw_finish();
            } else {
                this.setupBackgroundList();
            }
        },
        drawBackgroundLayer: function () {
            var backSource, active_source;
            var layerId = this.backgroundList.shift();
            if (layerId) {
                var active_layer = this.get_active_layer();
                if (active_layer) {
                    active_source = active_layer.get_source_obj();
                }
                var backLayer = this.get_layer_with_id(layerId);
                if (backLayer) {
                    backSource = backLayer.get_source_obj();
                }

                if (backSource && active_source && active_source.drawn && backSource.checkForRender(active_source.getRenderedResolution(), active_source.getRenderedExtent())) {
                    backLayer.background_draw_setup();
                } else {
                    this.drawBackgroundLayer();
                }
            }
        },
        on_add_layer_background: function (layer_obj) {
            layer_obj.addEvent("draw_image_canvas", this.onBackgroundDrawStart.bind(this));
            layer_obj.addEvent(OCS.Viewer.Config.events.LAYER_DRAW_FINISH, this.onBackgroundDrawFinish.bind(this));
        },
        on_layer_active: function () {
            var layer = this.get_active_layer();
            if (this.backgroundList && layer) {
                var backLayerIndex = this.backgroundList.indexOf(layer.get_id());
                if (backLayerIndex > -1)
                    this.backgroundList.splice(backLayerIndex, 1);
            }
        }

    };
};
OCS.Viewer.Functions.define_layer_group_background_interface();